import React from 'react';

interface TooltipProps {
  content: string;
  children: React.ReactNode;
  disabled?: boolean;
}

const Tooltip: React.FC<TooltipProps> = ({ children }) => {
  return (
    <div style={{ display: 'inline-block' }}>
      {children}
    </div>
  );
};

export default Tooltip;